import React, { useState } from 'react';
import { Box, Flex, Text, Input, IconButton, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import AleaCopyIcon from '../../icons/AleaCopyIcon';
import AleaCheckIcon from '../../icons/AleaCheckIcon';
import AleaRefreshIcon from '../../icons/AleaRefreshIcon';

interface CareHomeIdDisplayProps {
  careHomeId: string;
  onRefresh?: () => void;
}

const CareHomeIdDisplay: React.FC<CareHomeIdDisplayProps> = ({
  careHomeId,
  onRefresh,
}) => {
  const { t } = useTranslation();
  const toast = useToast();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    if (!careHomeId) return;

    navigator.clipboard.writeText(careHomeId);
    setCopied(true);
    toast({
      title: t('general.copiedToClipboard'),
      status: 'success',
      duration: 2000,
      isClosable: true,
    });

    setTimeout(() => setCopied(false), 2000);
  };

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <Flex alignItems="center">
      <Text
        fontSize="18px"
        fontWeight={400}
        color="alea.500"
        whiteSpace="nowrap"
        mr="12px"
      >
        {t('careHomeID')}
      </Text>
      <Flex position="relative" alignItems="center" mr="5px" maxW="180px" w="100%">
        <Input
          value={careHomeId || ''}
          readOnly
          bg="white"
          borderRadius="20px"
          border="1px solid #DCDCDC"
          height="50px"
          w="100%"
          pr="50px"
          color="black"
          fontWeight={500}
          fontSize="18px"
          _focus={{ borderColor: '#DCDCDC' }}
          _focusVisible={{ borderColor: '#DCDCDC' }}
          cursor="default"
        />
        {careHomeId && (
          <Box
            position="absolute"
            right="12px"
            cursor="pointer"
            onClick={copyToClipboard}
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={2}
            pointerEvents="auto"
          >
            {copied ? (
              <AleaCheckIcon color="#2B4956" size="19" />
            ) : (
              <AleaCopyIcon color="#2B4956" size="22" />
            )}
          </Box>
        )}
      </Flex>
      {onRefresh && (
        <IconButton
          aria-label={t('refresh')}
          icon={<AleaRefreshIcon color="white" size="18" />}
          onClick={handleRefresh}
          borderRadius="full"
          bg="alea.500"
          color="white"
          size="lg"
          h="50px"
          w="50px"
          _hover={{ bg: 'alea.600' }}
        />
      )}
    </Flex>
  );
};

export default CareHomeIdDisplay;

